<template>
  <v-layout @click="goToLivechat" class="user">
    <v-avatar size="40" class="ma-2">
      <!-- '/static/img/assets/livechat/profile.png' -->
      <img :src="value.profile_pic" @error="onFailLoad" />
    </v-avatar>
    <v-flex class="pa-2">
      <div class="text-truncate">{{value.first_name}} {{value.last_name}}</div>
      <div class="caption grey--text">{{customerWaitingTime}}</div>
      <!-- <v-chip round color="red" text-color="white" disabled small class="ma-0 mt-2">รอนาน</v-chip>
            <v-chip
              round
              color="success"
              text-color="white"
              disabled
              small
              class="ma-0 mt-2"
      >ลูกค้าใหม่</v-chip>-->
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  props: ['value'],
  data: function() {
    return {}
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  computed: {
    customerWaitingTime: function() {
      var vm = this

      var updatetime = moment(vm.value.updatetime)
      var now = moment()

      if (vm.value.adminupdatetime != null) {
        var adminupdatetime = moment(vm.value.adminupdatetime)

        if (adminupdatetime.diff(updatetime) >= 0) {
          return 'รอลูกค้าตอบกลับ'
        }
      }
      return vm.getTimeFormat(now, updatetime)
    }
  },
  methods: {
    getTimeFormat: function(date1, date2) {
      if (date1.diff(date2, 'days') > 0) {
        return date1.diff(date2, 'days') + ' วัน'
      } else if (date1.diff(date2, 'hours') > 0) {
        return date1.diff(date2, 'hours') + ' ชม'
      } else if (date1.diff(date2, 'minutes') > 0) {
        return date1.diff(date2, 'minutes') + ' นาที'
      } else if (date1.diff(date2, 'seconds') > 0) {
        return date1.diff(date2, 'seconds') + ' วินาที'
      }
    },
    onFailLoad: function() {
      this.$set(this.value, 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    goToLivechat: function() {
      let routeData = this.$router.resolve({
        name: 'livechat',
        path: '/' + this.currentLang + '/livechat',
        query: {
          userid: this.value.id
        }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.user {
  cursor: pointer;
  &:hover {
    background: #eee;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/view/template/qualityexpress/StatusUser.vue